import React, { useContext } from "react"
import * as styles from "./RequestPrice.module.scss"
import { PriceContext } from "../PriceContext"

const RequestPrice = () => {
  const { text } = useContext(PriceContext)
  return <div className={styles.request} dangerouslySetInnerHTML={{ __html: text.addonText.request }} />
}

export default RequestPrice
